<template>
	<div class="jifenMyBox" v-loading.fullscreen.lock="fullscreenLoading">
		<div class="jifenMyTop">
			<div class="jifenMyTopL">
				<div class="jifenMyTopTit">
					<h2>我的优积分</h2>
					<p>{{ tipData.configValue }}</p>
				</div>
				<div class="jifenMyTopTj">
					<div class="jifenMyTopTitem">
						优积分：{{ infoData.totalIntegral || 0 }}
						<img src="@/assets/img/yjf.png" alt="" />
					</div>
					<div class="jifenMyTopTitem">今日获得：{{ infoData.integralTodayGet || 0 }}</div>
					<div class="jifenMyTopTitem">今日消耗：{{ infoData.integralTodaySubtracting || 0 }}</div>
				</div>
			</div>
			<div class="jifenMyTopR">
				<img src="@/assets/img/img.png" alt="" />
			</div>
		</div>
		<div class="jifenMyCont">
			<div class="jifenMyContTit">
				<div class="jifenMyContBd">变动数量</div>
				<div class="jifenMyContYy">变动原因</div>
				<div class="jifenMyContTime">变动时间</div>
				<div class="jifenMyContJf">积分</div>
			</div>
			<div class="jifenMyContP" v-for="(item, index) in jfData" :key="index">
				<div class="jifenMyContBd">
					<span>{{ item.num }}</span>
				</div>
				<div class="jifenMyContYy" :class="{ active: item.changetype == 1 }">
					<span>{{ item.content }}</span>
				</div>
				<div class="jifenMyContTime">
					<span>{{ item.createTime | momentYR('YYYY年MM月DD日') }}</span>
				</div>
				<div class="jifenMyContJf" :class="{ active: item.changetype == 1 }">
					<span v-if="item.num">{{ item.changetype != 1 ? '+' : '-' }}{{ item.num }}积分</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'jifenMy',
	data() {
		return {
			jfData: [],
			infoData: {},
			tipData: {},
			fullscreenLoading: false
		};
	},
	methods: {
		init() {
			this.fullscreenLoading = true;
			this.$http.get('api/app/yydIntegralRecord/list/allToday').then((res) => {
				if (res.code == 200) {
					console.log(res);
					this.infoData = res.data || {};
				}
			});
			this.$http.get('api/app/yydIntegralRecord/list').then((res) => {
				this.fullscreenLoading = false;
				if (res.code == 200) {
					console.log(res);
					this.jfData = res.rows;
				}
			});
			this.$http.get(`api/system/dict/data/config/app.integral.tips`).then((res) => {
				this.fullscreenLoading = false;
				if (res.code == 200) {
					console.log(res);
					this.tipData = res.data;
				}
			});
		}
	},
	mounted() {
		this.init();
	}
};
</script>
<style lang="scss" scoped>
.jifenMyBox {
	flex: 1;
	margin-left: 10px;
	background: #fff;
	.jifenMyCont {
		.jifenMyContP {
			display: flex;
			align-items: center;
			height: 47px;
			font-size: 12px;
			text-align: center;
			border-bottom: 1px solid #f3f4f7;
			cursor: pointer;
			&:last-of-type {
				border-bottom: none;
			}
		}
		.jifenMyContTit {
			display: flex;
			align-items: center;
			height: 47px;
			font-size: 12px;
			font-weight: bold;
			color: #000000;
			text-align: center;
			border-bottom: 1px solid #f3f4f7;
		}
		.jifenMyContBd {
			width: 120px;
			padding: 0 34px;
			span {
				color: #ababab;
			}
		}
		.jifenMyContYy {
			flex: 1;
			span {
				color: #1d7b3a;
			}
		}
		.jifenMyContTime {
			width: 130px;
			text-align: center;
			margin-right: 20px;
			span {
				color: #ababab;
			}
		}
		.jifenMyContJf {
			width: 160px;
			text-align: center;
			span {
				color: #1d7b3a;
			}
		}
		.active {
			span {
				color: #ff281c;
			}
		}
	}
	.jifenMyTop {
		height: 145px;
		background: linear-gradient(188deg, rgba(153, 180, 104, 1) 0%, #8baf61 17%, #52a56b 100%);
		border-radius: 6px 6px 0px 0px;
		display: flex;
		padding-left: 12px;
		.jifenMyTopL {
			width: 721px;
			.jifenMyTopTj {
				height: 75px;
				display: flex;
				align-items: center;
				color: #fff;
				font-size: 18px;
				padding-left: 11px;
				.jifenMyTopTitem {
					display: flex;
					margin-right: 80px;
					align-items: center;
					font-size: 18px;
					img {
						width: 20px;
						height: 20px;
						margin-left: 12px;
					}
				}
			}
			.jifenMyTopTit {
				height: 69px;
				line-height: 69px;
				color: #fff;
				border-bottom: 1px solid rgba(255, 255, 255, 0.12);
				padding-left: 11px;
				display: flex;
				h2 {
					font-size: 18px;
					margin-right: 33px;
				}
				p {
					font-size: 12px;
				}
			}
		}
		.jifenMyTopR {
			margin-right: 23px;
			flex: 1;
			text-align: right;
			img {
				height: 100%;
				width: 207px;
			}
		}
	}
}
</style>
